export function convertDate(dateString) {
  // Create a Date object from the string
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  // Extract day, month, and year
  const day = String(date.getUTCDate()).padStart(2, "0"); // Use getUTCDate() to avoid DST issues
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = date.getUTCFullYear(); // Use getUTCFullYear() for the full year

  // Format the date as DD/MM/YYYY
  const formattedDate = `${month}/${day}/${year}`;

  return formattedDate;
}

export function getAmountButtons(transactions, minTranAmount) {
  let updatedAmountButtons = [];

  if (transactions.offers.length > 0) {
    let amonutToPush = 0;
    updatedAmountButtons = transactions.offers.reduce((acc, item) => {
      amonutToPush += item.amount;
      acc.push(amonutToPush);
      return acc;
    }, []);

    // Sort by Min balance
    updatedAmountButtons = updatedAmountButtons.filter(
      (item) => item >= minTranAmount
    );

    // Sort by order
    if (updatedAmountButtons.length > 1) {
      updatedAmountButtons = updatedAmountButtons.sort((a, b) => a - b);

      // First element should be the total balance(ALL)
      const totalBalance =
        updatedAmountButtons[updatedAmountButtons.length - 1];
      updatedAmountButtons.pop();
      updatedAmountButtons.unshift(totalBalance);
    }

    // Max 8 buttons we will show in UI
    if (updatedAmountButtons > 8) {
      updatedAmountButtons = updatedAmountButtons.slice(0, 8);
    }
  }

  return { buttons: updatedAmountButtons };
}

export function updateGAConsent(cookieName) {
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  
  const ageGateCookie = getCookie(cookieName);
  const consentValue = ageGateCookie === 'a' ? 'granted' : 'denied';
    
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      'analytics_storage': consentValue
    });
  } else {
    console.warn('gtag not loaded - could not update consent');
  }
}